import api from '../../plugins/api';

const createRecord = (params) => {
  return api.post('/api/crm/services/createServiceRecord', params);
};

export default createRecord;